/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Box } from '@mui/material';
import { useRecoilState } from 'recoil';
import { useMutation } from 'react-query';
import axios, { endPoints } from 'api/request';
import Select from 'components/select';
import { sspSubmitOrder } from 'pages/provisioning/store/couchbase';
import ProvisioningStyles from 'pages/provisioning/couchbase/style';

const Sector = () => {
    const [isTouched, setIsTouched] = React.useState(false);
    const [order, setOrder] = useRecoilState(sspSubmitOrder);
    const [options, setOptions] = React.useState([]);
    const setSector = (sector, sectorDetails) => {
        setOrder({ ...order, sector, sectorDetails });
    };
    const sectorApi = useMutation(() => axios.get(`${endPoints.ssp.vm.sector}`));
    const seldValueExistsInOptions = (sectorValue) => options.find((option) => sectorValue === option?.value);
    const handleOnSelectChange = (selected) => {
        if (seldValueExistsInOptions(selected?.value)) {
            setSector(selected?.value, selected?.data);
        }
    };

    React.useEffect(() => {
        if (sectorApi?.isSuccess) {
            if (sectorApi?.data?.data?.sectors) setOptions(sectorApi?.data?.data?.sectors.map((app) => ({ label: app.name, value: app.name, data: app })));
        }
    }, [sectorApi?.isSuccess]);

    React.useEffect(() => {
        if (options && options?.length === 1 && !order?.sector) {
            setOrder({ ...order, sector: options?.[0]?.name, sectorDetails: options?.[0]?.data });
        }
        if (options && options?.length && order?.sector) {
            const sector = seldValueExistsInOptions(order?.sector);
            if (sector) setOrder({ ...order, sector: sector?.data?.name, sectorDetails: sector?.data });
        }
    }, [options]);

    React.useEffect(() => {
        sectorApi.mutate();
        // eslint-disable-next-line
    }, [order?.entityDetails?.sector]);

    React.useEffect(() => {
        if (!order?.sector && order?.isTouched) setIsTouched(true);
    }, [order?.sector, order?.isTouched]);

    return (
        <Box sx={ProvisioningStyles.box}>
            <Select
                key="sectorName"
                label="Primary Sector *"
                value={order?.sector || null}
                options={options}
                handleOnSelect={(value) => handleOnSelectChange(value)}
                disabled={sectorApi.isLoading}
                isLoading={sectorApi.isLoading}
                isRequired={isTouched}
            />
        </Box>
    );
};

export default React.memo(Sector);
